import { IMG } from './shared';

/* Channel tabs for the "Ready for leads when you are" section, ported from the
   v0 lib/marketing-channels.ts. A platform renders its logo when present,
   otherwise a hand-built wordmark or a monogram in its brand color. */

export const TABS = [
  {
    key: 'social',
    label: 'Social Media',
    description:
      'Easily connect your social media to your platform and turn followers into paying renters and renters into loyal followers from every channel.',
  },
  {
    key: 'search',
    label: 'Search & Maps',
    description:
      'Show up the moment renters search and pull up the map — so your business is the first they find, everywhere they look.',
  },
  {
    key: 'travel',
    label: 'Online leads',
    description:
      'Turn leads from online travel agencies directly into your rental business for accounts who qualify.',
  },
];

export const PLATFORMS = {
  travel: [
    { name: 'Expedia', logo: `${IMG}/brand-logos/expedia.svg` },
    { name: 'Kayak', monogram: 'K', color: '#FF690F' },
    { name: 'Priceline', monogram: 'P', color: '#0068EF' },
    { name: 'Booking.com', wordmark: 'booking' },
    { name: 'Travelocity', monogram: 'T', color: '#1478CD' },
    // The Turo tag mark is a wide lockup; object-fit: contain in a square box
    // fits it to the box width, so it lands well inside the circle.
    { name: 'Turo', logo: `${IMG}/brand-logos/turo.png` },
    { name: 'Orbitz', logo: `${IMG}/brand-logos/orbitz.png`, fullBleed: true },
    { name: 'TripAdvisor', logo: `${IMG}/brand-logos/tripadvisor.svg` },
  ],
  social: [
    { name: 'Facebook', logo: `${IMG}/brand-logos/facebook.svg` },
    { name: 'Instagram', logo: `${IMG}/brand-logos/instagram.svg` },
    { name: 'TikTok', logo: `${IMG}/brand-logos/tiktok.svg` },
    { name: 'YouTube', logo: `${IMG}/brand-logos/youtube.svg` },
    { name: 'LinkedIn', logo: `${IMG}/brand-logos/linkedin.svg` },
    { name: 'X', logo: `${IMG}/brand-logos/x.svg` },
    { name: 'Reddit', logo: `${IMG}/brand-logos/reddit.svg` },
    { name: 'Nextdoor', logo: `${IMG}/brand-logos/nextdoor.svg` },
  ],
  search: [
    { name: 'Google Search', logo: `${IMG}/brand-logos/google.svg` },
    { name: 'Google Business Profile', monogram: 'GBP', color: '#4285F4' },
    { name: 'Google Maps', logo: `${IMG}/brand-logos/google-maps.svg` },
    { name: 'Bing Places', logo: `${IMG}/brand-logos/bing.svg` },
    { name: 'Apple Maps', logo: `${IMG}/brand-logos/apple.svg` },
    { name: 'Yelp', logo: `${IMG}/brand-logos/yelp.svg` },
  ],
};
